import { Component, Inject, OnInit, AfterViewInit, Injector, Input } from "@angular/core";
import { DataService } from "../../services/data/data.service";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { SettingsClient, Account } from "../../api/DixApiClient";
import { HttpClient } from "@angular/common/http";
import * as API from "../../api/DixApiClient";
import { AppComponentBase } from "../../services/AppComponentBase";
import { showDemoUsersModal } from "../modals/demoUsers/show-demo-users-modal";
import { ShowYesNoOrderModal } from "../modals/yesno/yesno.component";
import { showLiveUsersModal } from "../modals/liveUsers/show-live-users-modal";
import { ShowMobileYesNoOrderModal } from "../modals/mobile-yesno/mobile-yesno.component";
import { ToastrService } from "ngx-toastr";
import { SimpleNotificationComponent } from "../simple-notification/simple-notification.component";
import { AccountProvider } from "../../model/workspace.data";
import { SwitchProviderRs } from "../../interfaces/service.response";
import { AChartComponent } from "../achart/achart.component";
import { Providers } from "../../enums/providers";

@Component({
    selector: "provider-select",
    template: require('./providerSelect.component.html'),
    styles: [require('./providerSelect.component.css')]
})
export class providerSelect extends AppComponentBase implements OnInit, AfterViewInit {
    @Input() public mode: string = "standard";

    ngAfterViewInit(): void {}

    ngOnInit(): void {}

    userProviders: any[] = [{ providerId: "DEMO" }];
    providers: any[] = [{ providerId: "DEMO" }];

    private httpClient: HttpClient;
    private _selectedProvider: Providers = Providers.DEMO;
    public get selectedProvider(): Providers {
        return this._selectedProvider;
    }
    public set selectedProvider(value: Providers) {
        this._selectedProvider = value;
    }

    constructor(
        //   private dataService: DataService,
        //    private workspaceService: WorkspaceServiceService,
        toastr: ToastrService,
        @Inject(HttpClient) http: HttpClient,
        injector: Injector
    ) {
        super(injector);
        this.httpClient = http;

        new API.OauthClient(http).getAccounts().subscribe((tp: any) => {
            this.providers = this.providers.concat(tp);
        });

        this.getData();

        this.globaGridMode.switchProviderSignal.subscribe(v => {
            // this.selectedProvider = v;
            //   this.changeProvider();

            if (v == true) {
                //  this.acceptAction(this.currentProvider);
                this.selectorWaiting = false;
            } else {
                this.acceptAction(v);
            }
        });

        let subscriber = this.dataService.dataSubscriber.subscribe(response => {
            if (response.Type == "SwitchProviderRs") {
                if (this.currentProvider != Providers.GAIN) {
                    let d = (response as SwitchProviderRs).ProviderInstruments;

                    if (d != undefined) this.workspace.runSymbolFilter(d);
                }
            }
        });

        this.globaGridMode.liveLoginAction.subscribe(v => {
            this.selectedProvider = v;
            this.selectorProvider = this.workspace.currentProvider;
        });
    }

    get currentProvider(): string {
        return this.workspace.currentProvider;
    }

    get showAccept(): boolean {
        return this.workspace.currentProvider != this.selectedProvider;
    }

    get currentUserId(): number {
        return this.workspace.userId;
    }

    public noAccounts: boolean = false;

    public isDebug: boolean = this.dataService.DebugVisibility;

    updateAccountList() {
        let selected = this.userProviders.find(provider => provider.providerId == this.selectedProvider);
        if (selected != null) {
            this.dataService
                .switchProvider(this.selectedProvider)
                .then(data => {
                    if (this.selectedProvider == "OANDA") {
                        let accounts: AccountProvider[] = [];

                        (data as any[]).forEach((item, index) => {
                            accounts.push(
                                new AccountProvider({
                                    id: index,
                                    accountName: item.AccountName,
                                    balance: item.Balance,
                                    pnL: item.PnL,
                                    accountProviderId: item.AccountID,
                                    Currency: item.Currency
                                })
                            );
                        });

                        this.workspace.accounts = accounts;

                        if (accounts.length > 0) {
                            this.workspace.activeAccountId = 0;
                            //   this.workspace.globaGridMode.activeAccountIdBySetSubscriber.next(this.workspace.activeAccountId);
                            let AccountID = (this.workspaceService.data.accounts as AccountProvider[]).filter(v => {
                                return v.id == 0;
                            })[0].accountProviderId;

                            this.dataService.sendRequest({
                                Cmd: DataService.TYPE_SWITCHACCOUNT,
                                Data: {
                                    AccountId: AccountID,
                                    Provider: this.selectedProvider,
                                    AccountID: AccountID
                                }
                            });
                        }
                        this.workspace.gainLoginResponse = undefined;
                    } else if (this.selectedProvider == "DEMO") {
                        this.workspace.AccountsClient.getAllByEmail(this.workspace.userName).subscribe(d => {
                            this.workspace.accounts = d;
                            if (d.length > 0) {
                                this.workspace.activeAccountId = d[0].id;

                                //    this.workspace.activeAccountIdBySet = this.workspace.activeAccountId;
                                this.workspace.globaGridMode.activeAccountIdBySetSubscriber.next(
                                    this.workspace.activeAccountId
                                );
                                this.workspace.providerWithoutAccounts = false;
                            }
                        });
                        this.workspace.gainLoginResponse = undefined;
                    }

                    this.workspace.globaGridMode.scanReset.next("newscan");
                    this.workspace.currentProvider = this.selectedProvider;
                    this.workspace.refreshAction();
                    this.selectorWaiting = false;
                })
                .catch(error => {
                    console.log(error);

                    let config = Object.assign(this.toastr.toastrConfig, {});
                    config.timeOut = 6000;
                    config.progressBar = true;
                    config.closeButton = true;
                    config.toastComponent = SimpleNotificationComponent;

                    let params: {} = {
                        error: true,
                        text: error
                    };

                    this.toastr.show(JSON.stringify(params), "", config);

                    if (error == "Cannot obtain id of account") {
                        this.bind_OANDA(this.selectedProvider);
                    }

                    //    this.selectedProvider = this.previousProviderID;
                    // this.workspace.accounts = [];
                    // this.workspace.currentProvider = this.selectedProvider;
                    // this.workspace.refreshAction();
                });
        } else {
            // //  window.location.href = `/api/oauth/request?provider=${ this.selectedProvider }&sessionKey=${ this.dataService.getSessionKey() }`;
            // this.dataService.switchProvider(this.selectedProvider)
            // let accounts: Account[] = [];
            // this.workspace.accounts = accounts;
            // this.workspace.providerWithoutAccounts = true;
            // window.location.href = `/api/oauth/request?provider=${ this.selectedProvider }&sessionKey=${ this.dataService.getSessionKey() }`;
            // this.workspace.currentProvider = this.selectedProvider;
            //  this.workspace.activeAccountId = 0;
            this.bind_OANDA(this.selectedProvider);
        }
        //  }
    }

    public bind_OANDA(provider: Providers) {
        this.dataService.switchProvider(this.selectedProvider);
        let accounts: Account[] = [];
        this.workspace.accounts = accounts;
        this.workspace.providerWithoutAccounts = true;
        window.location.href = `/api/oauth/request?provider=${
            this.selectedProvider
        }&sessionKey=${this.dataService.getSessionKey()}`;
        this.workspace.currentProvider = this.selectedProvider;
    }

    switchProvider(provider: any) {
        this.selectedProvider = provider.providerId;
    }

    switchProviderWithUpdate(provider: any) {
        if (this.workspace.currentProvider == provider.providerId) {
            this.selectorWaiting = false;
            return;
        }

        if (this.workspace.mobileMode == "desktop") {
            if (provider.providerId == "OANDA")
                ShowYesNoOrderModal(this.modalService).updateData(
                    "Connect To Live",
                    "Connect To Live?",
                    this,
                    provider.providerId,
                    true,
                    true,
                    "/images/providers/oanda-logo-b.png"
                );

            if (provider.providerId == "DEMO")
                ShowYesNoOrderModal(this.modalService).updateData(
                    "Switch To Demo",
                    "Switch To Demo?",
                    this,
                    provider.providerId,
                    true
                );

            if (provider.providerId == Providers.GAIN && this.workspace.providerModalHome) {
                this.workspace.providerModalHome.showProviderModal(Providers.GAIN).then(v => {
                    this.workspace.clearProviderData();
                    this.workspace.afterGainLogin(this.workspace.userId);
                    this.selectorWaiting = false;
                    this.workspace.refreshAction();
                });
            }
        } else {
            if (provider.providerId == "OANDA")
                ShowMobileYesNoOrderModal(this.modalService).updateData(
                    "Connect To Live",
                    "Connect To Live?",
                    this,
                    provider.providerId,
                    true
                );

            if (provider.providerId == "DEMO")
                ShowMobileYesNoOrderModal(this.modalService).updateData(
                    "Switch To Demo",
                    "Switch To Demo?",
                    this,
                    provider.providerId,
                    true
                );

            if (provider.providerId == Providers.GAIN && this.workspace.providerModalHome)
                this.workspace.providerModalHome.showProviderModal(Providers.GAIN).then(v => {
                    this.workspace.clearProviderData();
                    this.workspace.afterGainLogin(this.workspace.userId);
                    this.selectorWaiting = false;
                    this.workspace.refreshAction();
                });
        }
    }

    private _selectorWaiting: boolean = false;
    public get selectorWaiting(): boolean {
        return this._selectorWaiting;
    }
    public set selectorWaiting(value: boolean) {
        this._selectorWaiting = value;
        if (value == false) {
            this.selectorProvider = this.workspace.currentProvider;
        }
    }

    private _selectorProvider: Providers = this.workspace.currentProvider;
    public get selectorProvider(): Providers {
        return this._selectorProvider;
    }
    public set selectorProvider(value: Providers) {
        this._selectorProvider = value;
    }

    public updateProviderFromSelector(selected: Providers) {
        if (selected == this.currentProvider) {
            return;
        }
        const temp = { providerId: selected };
        this.switchProviderWithUpdate(temp);
        this.selectorWaiting = true;
    }

    private _prevoiusProviderID: string = "";
    public get previousProviderID(): string {
        return this._prevoiusProviderID;
    }
    public set previousProviderID(value: string) {
        this._prevoiusProviderID = value;
    }

    public acceptAction(params: any) {
        this.workspace.clearProviderData();
        if (this.selectedProvider == this.workspace.currentProvider) {
            this.selectorWaiting = false;
        }

        this.previousProviderID = this.selectedProvider;
        this.selectedProvider = params;
        this.updateAccountList();
    }
    public cancelAction(params: any) {
        this.selectorWaiting = false;
    }

    getData() {
        if (this.workspace.userId != 0) {
            let settingClient: SettingsClient = new SettingsClient(this.httpClient);
            settingClient.getProviders(this.workspace.userId).subscribe(data => {
                this.userProviders = this.userProviders.concat(data);
            });
        } else {
            setTimeout(() => {
                this.getData();
            }, 1000);
        }
    }

    public showDemoUsersModal(): void {
        if (this.selectedProvider == Providers.OANDA)
            showLiveUsersModal(this.modalService, undefined, this.workspace.mobileMode);

        if (this.selectedProvider == Providers.DEMO)
            showDemoUsersModal(this.modalService, undefined, this.workspace.mobileMode);
    }

    public get Providers() {
        return Providers;
    }
}
